/**
 * Admin Automation Conditions (editor metadata) Hook
 *
 * Cached React Query hook for GET /api/admin/automations/conditions/ — the
 * situations + guards (with params schemas), existing automation slugs, email
 * template variants, default sender name and the state / trigger choices the
 * editor renders its forms from. The registry is code-defined, so the data is
 * kept fresh for a long time and only re-fetched when an automation is
 * created / deleted / renamed (see useAdminAutomations).
 */

import { useQuery } from "@tanstack/react-query";
import { adminAutomationConditions } from "../utils/adminApi";

export const ADMIN_AUTOMATION_CONDITIONS_QUERY_KEY = ["admin", "automations", "conditions"];

const EMPTY_META = Object.freeze({
  situations: [],
  guards: [],
  automation_slugs: [],
  email_template_variants: [],
  default_sender_display_name: "",
  states: [],
  trigger_types: [],
});

export const useAdminAutomationConditions = ({ enabled = true } = {}) => {
  const query = useQuery({
    queryKey: ADMIN_AUTOMATION_CONDITIONS_QUERY_KEY,
    queryFn: () => adminAutomationConditions(),
    enabled,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  return { ...query, meta: query.data || EMPTY_META };
};

export default useAdminAutomationConditions;
